module.exports = __webpack_public_path__ + "img/sprite.68791ca8.svg";